export default __webpack_public_path__ + "static/media/calculator-2.1abc57bd.svg";